"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDuration = exports.formatDuration = exports.UNIT_OF_TIME = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../constants");
const getRoundedDurationByDigit_1 = require("./getRoundedDurationByDigit");
exports.UNIT_OF_TIME = {
    years: 'years',
    months: 'months',
    weeks: 'weeks',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds',
    milliseconds: 'milliseconds',
};
const FORMAT_MAP = {
    day: 'd',
    hour: 'h',
    minute: 'min',
    second: 'sec',
};
const formatDuration = (config, formatMap = FORMAT_MAP) => Object.keys(config)
    .filter((key) => config[key])
    .map((key) => `${config[key]} ${formatMap[key]}`)
    .join(' ');
exports.formatDuration = formatDuration;
const getFormattedDuration = ({ durationValue, unit = exports.UNIT_OF_TIME.milliseconds, emptyValue = constants_1.EMPTY_TEXT.dash, formatMap = FORMAT_MAP, maxItems, } = {}) => {
    let value = '';
    if (!durationValue || !isFinite(durationValue)) {
        value = emptyValue;
    }
    else {
        let d = moment_1.default.duration(Number(durationValue), unit);
        d = getRoundedDurationByDigit_1.getRoundedDurationByDigit(d, maxItems);
        if (d.asMilliseconds() < 500) {
            value = `0 ${formatMap === null || formatMap === void 0 ? void 0 : formatMap.second}`;
        }
        else {
            value = exports.formatDuration({
                day: d.milliseconds() >= 500 && d.seconds() === 59 && d.minutes() === 59 && d.hours() === 23
                    ? d.days() + 1
                    : d.days(),
                hour: d.milliseconds() >= 500 && d.seconds() === 59 && d.minutes() === 59
                    ? d.hours() === 23
                        ? 0
                        : d.hours() + 1
                    : d.hours(),
                minute: d.milliseconds() >= 500 && d.seconds() === 59
                    ? d.minutes() === 59
                        ? 0
                        : d.minutes() + 1
                    : d.minutes(),
                second: d.milliseconds() >= 500 ? (d.seconds() === 59 ? 0 : d.seconds() + 1) : d.seconds(),
            }, formatMap);
        }
    }
    return value;
};
exports.getFormattedDuration = getFormattedDuration;
//# sourceMappingURL=getFormattedDuration.js.map